import { BOX_TYPES } from "./BoxTypes";
import * as Box from "@/box";

export default function initializeBox(type, params) {
  switch (type) {
    case BOX_TYPES.SHIPPING:
      return new Box.ShippingBox({...params,});

    case BOX_TYPES.MAILER:
      return new Box.MailingBoxTL({ ...params });

    case BOX_TYPES.LITERATURE:
      return new Box.MailingBoxTI({ ...params });

    case BOX_TYPES.PIZZA:
      return new Box.PizzaBox({ ...params });
  }
}
